<template>
	<div id="app_schoolIndex">
		<dv-full-screen-container class="bg">
			<dv-loading v-if="loading">Loading...</dv-loading>
			<div v-else class="host-body">
				<!-- 第一行标题装饰条 -->
				<div class="d-flex jc-center title_bg">
					<div class="title">
						<span class="title-text">&#9658; {{ schoolName }}</span>
					</div>
				</div>
				<!-- 数据开始 -->
				<div class="body-box">
					<ul>
						<li :class="display1" @click="gotoModule('/dataView/area/school')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">校园概况</div>
							<img class="indexblock_img" src="../../assets/img/gaikaung.jpg">
						</li>
						<li :class="display5" @click="gotoModule('/dataView/security/school')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">校园安防</div>
							<div class="indexblock_img"><img src="../../assets/img/xyaf.jpg"></div>
						</li>
						<li :class="display2" @click="gotoModule('/dataView/quality/school')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">学生发展</div>
							<img class="indexblock_img" src="../../assets/img/zongping.jpg">
						</li>
						<li :class="display3" @click="gotoModule('/dataView/clubClass/school')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">课后服务</div>
							<img class="indexblock_img" src="../../assets/img/kehou.jpg">
						</li>
						<li :class="display4" @click="gotoModule('/dataView/threeClass/school')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">三个课堂</div>
							<img class="indexblock_img" src="../../assets/img/sgkt.jpg">
						</li>
						<li :class="display6" @click="gotoModule('/dataView/dorm/school')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">智慧宿舍</div>
							<img class="indexblock_img" src="../../assets/img/zhsushe.jpg">
						</li>
						<li :class="display7" @click="gotoModule('zhkt')">
							<div class="indexblock_bgimg"><img src="../../assets/img/indexblock_bg.png"></div>
							<div class="indexblock_tit">智慧课堂</div>
							<img class="indexblock_img" src="../../assets/img/zhkt.jpg">
						</li>
					</ul>
				</div>
			</div>
		</dv-full-screen-container>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
var orgCode = storage.getItem("orgCode");
var schoolName = storage.getItem("schoolName");
export default {
	data() {
		return {
			loading: true,
			schoolName: schoolName,
			display1: "hidden",
			display2: "hidden",
			display3: "hidden",
			display4: "hidden",
			display5: "hidden",
			display6: "hidden",
			display7: "show"
		};
	},
	mounted() {
		this.cancelLoading();
		this.initData();
	},
	methods: {
		//关闭loading加载条
		cancelLoading() {
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
		initData() {
			let _this = this;
			this.$http.get("/dataView/dataViewIndex?orgId=" + orgId).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					if (result.indexOf("2096") != -1) {
						_this.display1 = "show";
					}
					if (result.indexOf("2097") != -1) {
						_this.display2 = "show";
					}
					if (result.indexOf("2102") != -1) {
						_this.display3 = "show";
					}
					if (result.indexOf("2103") != -1) {
						_this.display4 = "show";
					}
					if (result.indexOf("2104") != -1) {
						_this.display5 = "show";
					}
					if (result.indexOf("2100") != -1) {
						_this.display6 = "show";
					}
				}
			});
		},
		gotoModule(path) {
			if (path == '/dataView/dorm/school') {
				this.$router.push({ path: path, query: { orgCode: orgCode, buildIds: '' } });
			} else if (path == '/dataView/threeClass/school') {
				window.AndroidWebView.openAndroidPage(orgId);
			} else if (path == '/dataView/security/school') {
				window.AndroidWebView.openAndroidPage_security(orgId);
			} else if (path == 'zhkt') {
				window.AndroidWebView.openWisdomClass();
			} else {
				this.$router.push({ path: path, query: { orgCode: orgCode } });
			}
		}
	},
	// 注意在vue实例销毁前，清除我们的定时器。
	destroyed() {
		
	}
};
</script>

<style lang="scss">
#app_schoolIndex {
	background-color: #181b37;
	width: 100%;
	min-height: 100vh;
	background-image: url("../../assets/img/after_bg.jpg");
	background-size: 100% 100%;

	.full_screen {
		width: 0.8rem;
		height: 0.8rem;
		position: absolute;
		top: 0.32rem;
		right: 0.5rem;
		font-size: 0.2rem;
		color: #55ffff;
		font-weight: bold;
		-webkit-background-clip: text;
		background-image: linear-gradient(90deg, #55ffff, #55aaff);
		-webkit-text-fill-color: transparent;
		cursor: pointer;
	}

	.bg {
		padding: 0.2rem 0.2rem 0 0.2rem;
		background-position: center center;
	}

	.title_bg {
		width: 100%;
		height: 8vh;
		background: url("../../assets/img/indextit_bg.png") center no-repeat;

		.title {
			width: 100%;
			text-align: left;

			.title-text {
				display: inline-block;
				font-size: 0.25rem !important;
				font-weight: bold;
				line-height: 0.25rem;
				margin-left: 0;
				margin-top: 0.25rem;
				background-image: linear-gradient(135deg, #55ffff, #54c3ff);
				-webkit-background-clip: text;
				color: transparent;
			}
		}
	}

	//下方区域的布局
	.body-box {
		width: 100%;
		height: 80vh;
		margin-top: 0.5rem;
		overflow: hidden;

	}

	.body-box ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		height: 100%;
		box-sizing: border-box;
	}

	.body-box ul li {
		width: 24%;
		height:4.6rem;
		margin: 0 0.11rem 0;
		position: relative;
	}

	.body-box ul li:hover {
		cursor: pointer;
	}

	.indexblock_bgimg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}

	.indexblock_img {
		width: 95%;
		height: 65%;
		border-radius: 0.1rem;
		position: absolute;
		top: 20%;
		left: 4%;
	}

	.indexblock_bgimg img,
	.indexblock_img img {
		width: 100%;
		height: 100%;
	}

	.indexblock_tit {
		font-size: 0.25rem;
		font-weight: bold;
		background-image: linear-gradient(135deg, #55ffff, #54c3ff);
		-webkit-background-clip: text;
		color: transparent;
		position: absolute;
		top: 0.22rem;
		left: 0.6rem;
	}

	.indexblock_click {
		display: inline-block;
		font-size: 0.2rem;
		font-weight: bold;
		background-image: linear-gradient(135deg, #55ffff, #54c3ff);
		-webkit-background-clip: text;
		color: transparent;
		position: absolute;
		bottom: 0.1rem;
		right: 0.45rem;
	}

	.indexblock_click:hover {
		cursor: pointer;
	}

	.show {
		display: block;
	}

	.hidden {
		display: none;
	}
}
</style>